{
    "default": {
        "welcomeEmail": true,
        "cxiLicence": "NONE"
    },
    "NONE": {
        "licenceLevel": "None",
        "mobileAppEnabled": false,
        "defaultReportsCollection": "",
        "allowEmailAsUsername": true,
        "isSelfScoped": false,
        "requiresEndpoint": true
    },
    "ESSENTIALS": {
        "licenceLevel": "Essentials",
        "mobileAppEnabled": false,
        "defaultReportsCollection": "Essentials_Reports",
        "allowEmailAsUsername": false,
        "isSelfScoped": true,
        "requiresEndpoint": false
    },
    "PROFESSIONAL": {
        "licenceLevel": "Professional",
        "mobileAppEnabled": false,
        "defaultReportsCollection": "Professional_Reports",
        "allowEmailAsUsername": false,
        "isSelfScoped": false,
        "requiresEndpoint": true
    },
    "ENTERPRISE": {
        "licenceLevel": "Enterprise",
        "mobileAppEnabled": false,
        "defaultReportsCollection": "Standard_Reports",
        "allowEmailAsUsername": true,
        "isSelfScoped": false,
        "requiresEndpoint": true
    },
    "CALL_CENTRE_AGENT": {
        "licenceLevel": "Call Centre Agent",
        "mobileAppEnabled": false,
        "defaultReportsCollection": "Call_Centre_Agent_Reports",
        "allowEmailAsUsername": false,
        "isSelfScoped": false,
        "requiresEndpoint": true
    },
    "CALL_CENTRE_SUPERVISOR": {
        "licenceLevel": "Call Centre Supervisor",
        "mobileAppEnabled": false,
        "defaultReportsCollection": "Enhanced_Call_Center_Reports",
        "allowEmailAsUsername": true,
        "isSelfScoped": false,
        "requiresEndpoint": true
    },
    "CXA_Advanced": {
        "licenceLevel": "Call Centre Supervisor",
        "mobileAppEnabled": false,
        "defaultReportsCollection": "Standard_Reports",
        "allowEmailAsUsername": true,
        "isSelfScoped": false,
        "requiresEndpoint": true
    },
    "WxC_Supervisor": {
        "licenceLevel": "Call Centre Supervisor",
        "mobileAppEnabled": false,
        "defaultReportsCollection": "Standard_Reports",
        "allowEmailAsUsername": true,
        "isSelfScoped": false,
        "requiresEndpoint": true
    }
}
